import React from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  title?: string
  content?: string
}

const BlockedPage: React.FunctionComponent<IProps> = props => {
  const { t } = useTranslation()
  const { title, content } = props

  return (
    <div className="information-container">
      <div>
        <h3>{title || t('blocked-page.title')}</h3>
      </div>
      <div>{content || t('blocked-page.content')}</div>
    </div>
  )
}

export default BlockedPage
